"use client";

import { type ReactNode } from "react";

import { PlaceCard } from "~/components/blocks/place-card";
import { Cards } from "~/components/cards";
import { type PlaceProps } from "~/lib/fragments";

export function PlaceCards({
  title,
  places,
}: {
  title: ReactNode;
  places: PlaceProps[];
}) {
  return (
    <Cards
      items={places.map((place) => ({ place, id: place.id }))}
      title={title}
      CardComponent={PlaceCard}
    />
  );
}
